import React from "react";
import { Redirect } from "react-router";
import { styled } from "@mui/material/styles";

import { Logo } from "../../../components/Logo";
import { Link } from "../../../components/Link";
import { Grid } from "../../../UI/Grid";
import { Button } from "../../../UI/MUIButton";
import { Typography } from "../../../UI/Typography";
import { HOME_URL } from "../../HomePage/HomePage";
import { COLOR_PRIMARY, COLOR_TUNA, COLOR_WHITE } from "../../../constants/styles";
import { CLIENTS_EMAIL_ADDRESS, DEFAULT_CONTACT_URL, ROOMSYNC_WEBSITE } from "../../../constants/general";

import useAuth from "../AuthContext";
import {getAppConfig} from "../../../AppConfig";

const StyledLogo = styled(Logo)`
  width: 262px;
  height: 53px;
`;

const StyledHouseImg = styled("img")`
  width: 253px;
  height: 155px;
`;

const StyledGoogleIcon = styled("img")`
  width: 22px;
  height: 22px;
`;

const StyledButton = styled(Button)`
  width: 395px;
  height: 50px;
  text-transform: capitalize;
  color: ${COLOR_TUNA};
  border: 2px solid ${COLOR_TUNA};
  font-weight: 600;
  font-size: 17px;
`;

const StyledFooterLink = styled(Link)`
  color: ${COLOR_WHITE};
  font-size: 14px;

  &:hover {
    color: ${COLOR_WHITE};
  }
`;

const LoginContainer = (props) => {
  const { isLoggedIn, federatedLogin } = useAuth();
  let hostNames = window.location.hostname.split(".");

  let appConfig = getAppConfig();

  let provider = appConfig.provider;
  let startIcon = undefined;

  if (hostNames.length >= 1) {
    switch (hostNames[0]) {
      case "localhost":
      case "stagingadmin":
      case "admin":
        startIcon = <StyledGoogleIcon src="/static/images/google-icon.png" alt="" aria-hidden="true" />;
        break;
      default:
        break;
    }
  }

  if (isLoggedIn()) {
    return <Redirect to={HOME_URL} />;
  }

  const handleLogin = () => federatedLogin(provider);

  return (
    <Grid container alignItems="center" justifyContent="center" bgcolor={COLOR_PRIMARY} height="100%">
      <Grid item>
        <Grid container spacing={2}>
          <Grid item xs={12} display="flex" justifyContent="center">
            <StyledLogo marginTop={0} marginBottom={0} type="white" />
          </Grid>
          <Grid item xs={12} display="flex" justifyContent="center">
            <Grid
              p={6}
              item
              container
              width={491}
              bgcolor="white"
              borderRadius={3}
              direction="column"
              alignItems="center"
              boxShadow="0px 15px 50px rgba(160, 163, 189, 0.1)"
            >
              <Grid item>
                <StyledHouseImg src="/static/images/house.png" />
              </Grid>
              <Grid item mt={6}>
                <Typography variant="h6">Administrator Login Portal</Typography>
              </Grid>
              <Grid item mt={3}>
                <Typography variant="body2" align="center" color="text.secondary">
                  Login to access the RoomSync Admin site. If you do not have an account or are unable to login, please
                  contact RoomSync for assistance at{" "}
                  <Link href={`mailto:${CLIENTS_EMAIL_ADDRESS}`}>{CLIENTS_EMAIL_ADDRESS}</Link>
                </Typography>
              </Grid>
              <Grid item mt={3}>
                <StyledButton fullWidth size="large" onClick={handleLogin} startIcon={startIcon}>
                  {provider} Login
                </StyledButton>
              </Grid>
            </Grid>
          </Grid>
          <Grid item container justifyContent="center">
            <Grid item mb={4} mt="auto" color={COLOR_WHITE}>
              <StyledFooterLink href={DEFAULT_CONTACT_URL} mr={2}>
                Need help? Contact Us
              </StyledFooterLink>{" "}
              |{" "}
              <StyledFooterLink href={ROOMSYNC_WEBSITE} ml={2}>
                Learn more about RoomSync
              </StyledFooterLink>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default LoginContainer;

export const LOGIN_URL = "/";
